const EmptyLetsKnowEachotherDetails = () => {
  return {
    id:"",
    personID: "",
    employeeName: "",
    sswGoals: "",
    interestingFacts: "",
    hobbies: "",
    favouriteQuote: "",
    favouriteMovie: "",
    favouriteSong: "",
    favouriteBook: "",
    personalGoals: "",
    familyIntroduction: "",
    image: "",
  };
};

export default EmptyLetsKnowEachotherDetails;
